import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — full-height shop glazing: a low kick panel (0 -> 0.3), one
// big glass pane up to 2.4 and a matte-black fascia band to the standard
// 2.6 m wall top, all in thin matte-black frame strips. Same tile-long,
// 0.12 m thick wall convention as wall-plain, so it chains into shop fronts.
const BLACK = "#2e2e30";
const BLACK_LIGHT = "#3c3c3f";
const GLASS = "#9fc4d4";

export const storefrontWindow = defineModel({
  id: "storefront-window",
  batchId: "modern",
  name: "Storefront window",
  tags: ["modern", "outdoor", "structure", "wall", "window", "shop", "storefront"],
  summary: "Full-height shop glazing: kick panel, big glass pane to 2.4 m, matte-black frame.",
  description:
    "A one-tile modern shop-front glazing piece of the Modern Living kit: a " +
    "0.3 m matte-black kick panel, a full glass pane up to 2.4 m in thin " +
    "matte-black frame strips and a black fascia band to the 2.6 m wall top. " +
    "Chain tiles for a wide storefront; pairs with storefront-door.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // kick panel at the bottom (0 -> 0.3)
      { geometry: new THREE.BoxGeometry(1.0, 0.3, 0.12), color: BLACK_LIGHT, position: [0, 0.15, 0] },
      // big glass pane (0.3 -> 2.4), slightly thicker than the frame strips
      { geometry: new THREE.BoxGeometry(0.9, 2.1, 0.08), color: GLASS, position: [0, 1.35, 0] },
      // vertical matte-black frame strips (mullions) at both edges
      { geometry: new THREE.BoxGeometry(0.06, 2.4, 0.12), color: BLACK, position: [-0.47, 1.2, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 2.4, 0.12), color: BLACK, position: [0.47, 1.2, 0] },
      // transom strip capping the kick panel
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 0.12), color: BLACK, position: [0, 0.33, 0] },
      // head strip at the top of the glass
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 0.12), color: BLACK, position: [0, 2.37, 0] },
      // fascia band up to the 2.6 m wall top
      { geometry: new THREE.BoxGeometry(1.0, 0.2, 0.12), color: BLACK_LIGHT, position: [0, 2.5, 0] },
    ];
  },
  animations: [],
});
